"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const GraphandFieldBoolean_1 = __importDefault(require("../lib/fields/GraphandFieldBoolean"));
const GraphandFieldJSON_1 = __importDefault(require("../lib/fields/GraphandFieldJSON"));
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
const GraphandFieldScope_1 = __importDefault(require("../lib/fields/GraphandFieldScope"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class Rule
 * @augments GraphandModel
 * @classdesc Rule model. Use {@link GraphandClient#getModel client.getModel("Rule")} to use this model
 */
class Rule extends GraphandModel_1.default {
}
Rule._customFields = {};
Rule.apiIdentifier = "rules";
Rule.baseUrl = "/rules";
Rule.scope = model_scopes_1.default.Rule;
Rule.envScope = model_env_scopes_1.default.ENV;
Rule.schema = {
    role: new GraphandFieldRelation_1.default({ ref: "Role", multiple: false }),
    scope: new GraphandFieldScope_1.default(),
    actions: new GraphandFieldText_1.default({
        multiple: true,
        options: ["create", "read", "update", "delete", "count", "login", "register", "execute"],
    }),
    prohibition: new GraphandFieldBoolean_1.default({ defaultValue: false }),
    conditions: new GraphandFieldJSON_1.default(),
};
exports.default = Rule;
